<template>
  <div style="margin-top: -20px;">
   
    <div class="login">
      <el-card style="border-top: 3px solid #ff8177;">
        <img src="@/assets/fo_logo.png" alt />
        <center><p>
          Para recuperar su contraseña ingrese los siguientes datos.
        </p></center>
        <el-form
          :label-position="'top'"
          style="padding: 0px 30px"
          :model="login"
          ref="login" :disabled="disabledForm" :loading="enviandoEmail"
        >
          <el-form-item
            label="Ingrese email o usuario"
            prop="email"
            :rules="[
              { required: true, message: 'Campo obligatorio', trigger: ['blur','change'] },
            ]"
          >
            <el-input
              v-model="login.email" placeholder="Ingrese su email o usuario"
              @keypress.native.prevent.enter="recuperarPass('login')" autocomplete="off" clearable
            >
            <template slot="prepend"><i class="el-icon-user-solid"></i></template>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="procesando"
              @click="recuperarPass('login')" icon="el-icon-thumb"
              class="btn-block"
              >Recuperar</el-button>
            <el-button  style="margin-left:0px !important;border-color: #ffffff;"              
              @click="regresarLink" icon="el-icon-back"
              class="btn-block"
              >Volver</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { HTTP,SC_prueba } from "@/axios.js";
export default {
  data() {
    return {
      login: {email:''},
      errorModal: false,
      procesando: false,
      error: "NONE",
      disabledForm:false,
      enviandoEmail:false
    };
  },
  created() {},
  methods: {
   recuperarPass(formName)
   {
     this.disabledForm = true
     this.enviandoEmail = true
     setTimeout(() => {
       this.$refs[formName].validate((valid) => {
          if (valid) 
          {
            this.disabledForm = false
            this.procesando = true;
            // alert(SC_prueba)
            // console.log(window.location.hostname)
            let url_btn = window.location.hostname
            HTTP.post( SC_prueba+"/recuperarLogin", {'email': this.login.email,'url': url_btn})
            .then((res) => {
              this.procesando = false;
              switch (res.data) {
                case 2:
                  this.$notify.error({
                    title: 'Error',
                    message: 'El usuario o email no existe',
                    offset: 200
                  });
                  break;
                case 3:
                  this.$notify.error({
                    title: 'Error',
                    message: 'El usuario no existe',
                    offset: 200
                  });
                  break;
                case 4:
                  this.$notify.error({
                    title: 'Error de envio',
                    message: 'No se pudo enviar el email. Intente nuevamente.',
                    offset: 200
                  });
                  break;
                default:
                   this.$notify.success({
                    title: 'Enviado!',
                    message: 'El email se envió correctamente, revise su casilla de correo',
                    offset: 200
                  });
                  break;
              }
              
    
            })
            .catch((error) => {
              this.procesando = false;
              console.log(error);  
            });
          }

       })
     }, 500);
   },
   regresarLink()
  {
    this.$router.push({name:'login'})
  }
  },
};
</script>

<style lang="scss" scoped>
.login {
  max-width: 400px;
  margin: 100px auto;
}
.login img {
  display: block;
  margin: 0 auto;
}
.tienda {
  position: relative;
}
.tienda-logo {
  padding: 10px;
  height: 75px;
  float: right;
}
.tienda-top {
  background: rgb(79, 76, 76);
  background: radial-gradient(
    circle,
    rgba(79, 76, 76, 1) 0%,
    rgba(22, 22, 21, 1) 100%
  );
  height: 60%;
  min-height: 60vh;
  // position: ab;
}
.tienda-bottom {
  background-color: rgba(225, 49, 54, 0.9);
  background-image: url("../assets/fondo-tienda.png");
  height: 40vh;
  // position: absolute;
}
.tiendas-form {
  width: 90%;
  max-width: 350px;

  position: absolute;
  top: 50%; /* position the top  edge of the element at the middle of the parent */
  left: 50%; /* position the left edge of the element at the middle of the parent */

  transform: translate(-50%, -50%);
}
.el-card.is-always-shadow {
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 33%);
}
@media (max-width: 600px) {
  .el-card.is-always-shadow {
    margin: 15px !important;
    }
  
}
</style>